<div id="wrapper">
<edc-demo-access-denied-banner *ngIf="isUnauthorized" resourceName="policies" details="Please sign in with an account that has access, or ask an admin to grant permissions."></edc-demo-access-denied-banner>

<ng-container *ngIf="!isUnauthorized">
    <div class="search-pagination-container">
      <mat-form-field appearance="outline" class="search-form-field" color="accent">
        <mat-label>Search policies</mat-label>
        <input (input)="onSearch()" [(ngModel)]="searchText" matInput [disabled]="isUnauthorized">
        <mat-icon matPrefix>search</mat-icon>
        <button (click)="searchText=''; onSearch()" *ngIf="searchText && !isUnauthorized" mat-icon-button matSuffix>
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    
      <mat-paginator
        [length]="totalPolicies"
        [hidePageSize]="false"
        [pageIndex]="paginationState.pageIndex"
        [pageSize]="paginationState.pageSize"
        [pageSizeOptions]="[10, 20, 50]"
        (page)="onPageChange($event)"
      />
    
      <button (click)="onCreate()" color="accent" mat-stroked-button>
        <mat-icon>add_circle_outline</mat-icon>
        Create policy
      </button>
    
    </div>

  <div fxLayout="column" fxLayoutAlign="space-around stretch">
    <mat-card *ngFor="let policyDef of paginationState.pagedList" class="policy-card">
      <mat-card-header>
        <mat-icon mat-card-avatar>attachment</mat-icon>
        <mat-card-title
          class="code overflow-ellipsis"
          [matTooltip]="utilService.shouldShowTooltip(idDiv, policyDef.id) ? policyDef.id : ''"
          #idDiv
          matTooltipPosition="below"
          matTooltipClass="tooltip"
        >
          {{policyDef.id}}
        </mat-card-title>
      </mat-card-header>

      <mat-card-content>

        <mat-list dense>
          <mat-list-item>
            <mat-icon matListItemIcon>trip_origin</mat-icon>
            <div matListItemTitle>{{policyDef.policy.assigner || 'n/a'}}</div>
            <div matListItemLine>Assigner</div>
          </mat-list-item>
          <mat-list-item>
            <mat-icon matListItemIcon>adjust</mat-icon>
            <div matListItemTitle>{{policyDef.policy.assignee || 'n/a'}}</div>
            <div matListItemLine>Assignee</div>
          </mat-list-item>
        </mat-list>

        <policy-rules 
        [permissionRules]="policyDef.policy.permissions" 
        [prohibitionRules]="policyDef.policy.prohibitions"
        [obligationRules]="policyDef.policy.obligations">
        </policy-rules>
      </mat-card-content>
      <mat-card-actions>
        <button (click)="onEdit(policyDef)" mat-stroked-button color="accent" matSuffix>
          <mat-icon>edit</mat-icon>
          Edit
        </button>
        <button class="delete-policy-button" (click)="delete(policyDef)" mat-stroked-button color="warn" matSuffix>
          <mat-icon>delete</mat-icon>
          Delete
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
  </ng-container>
</div>
